import { render, staticRenderFns } from "./IndexItem.vue?vue&type=template&id=e7c1d420&scoped=true&"
import script from "./IndexItem.vue?vue&type=script&lang=js&"
export * from "./IndexItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexItem.vue?vue&type=style&index=0&id=e7c1d420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c1d420",
  null
  
)

export default component.exports